import { Box, Typography, Button, styled } from "@mui/material";
import React from "react";
import { useState } from "react";
import { projects } from "../constants/project";
import Project from "./Project";
import Stack from "./Stack";

const Experience = () => {
  const [isOpen, setIsOpen] = useState(false);

  const CustomButton = styled(Button)(({ theme }) => ({
    border: "3px solid #B3565B",
    borderRadius: "25px",
    color: "white",
    width: "15%",
    display: "block",
    "&:hover": {
      border: "3px solid #B3565B",
      backgroundColor: "#B3565B",
    },
    [theme.breakpoints.down("md")]: {
      width: "50%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "75%",
      padding: "16px",
    },
  }));

  return (
    <Box id="projects" sx={{ maxWidth: "1300px", mx: "auto", my: 12 }}>
      <div
        style={{
          height: "5px",
          backgroundColor: "#B3565B",
          width: "60%",
          marginLeft: "auto",
          marginRight: "auto",
          border: 0,
          borderRadius: "25px",
          marginBottom: "90px",
        }}
      ></div>
      <Typography
        variant="h4"
        sx={{
          color: "white",
          textAlign: "center",
          mb: 6,
          fontSize: "30px",
          fontFamily: "'Arvo', serif;",
        }}
      >
        Här är några av mina projekt.
      </Typography>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
        }}
      >
        {projects.map((project, index) => (
          <Project
            key={project.id}
            title={project.title}
            description={project.description}
            tags={project.tags}
            img={project.image}
            source={project.source}
            liveVersion={project.liveVersion}
            hidden={index < 6 || isOpen ? "" : "none"} // set to empty string for first 5 projects, "none" for the rest
          />
        ))}
      </Box>

      <CustomButton
        onClick={() => setIsOpen(!isOpen)}
        variant="outlined"
        sx={{
          mx: "auto",
          mt: 3,
          mb: 8,
        }}
      >
        {isOpen ? "Visa mindre" : "Se fler"}
      </CustomButton>
      <Stack />
    </Box>
  );
};

export default Experience;
